import { render, staticRenderFns } from "./dangerousGoods.vue?vue&type=template&id=448c10b1&"
import script from "./dangerousGoods.vue?vue&type=script&lang=js&"
export * from "./dangerousGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448c10b1')) {
      api.createRecord('448c10b1', component.options)
    } else {
      api.reload('448c10b1', component.options)
    }
    module.hot.accept("./dangerousGoods.vue?vue&type=template&id=448c10b1&", function () {
      api.rerender('448c10b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/dangerousGoods.vue"
export default component.exports